export const usTerritories = [
  "US", // United States
  "840", // United States
  "AS", // American Samoa
  "016", // American Samoa
  "GU", // Guam
  "316", // Guam
  "MP", // Northern Mariana Islands
  "580", // Northern Mariana Islands
  "PR", // Puerto Rico
  "630", // Puerto Rico
  "UM", // US Minor Outlying Islands
  "581", // US Minor Outlying Islands
  "VI", // Virgin Islands
  "850", // Virgin Islands
]

/*
 * takes an iso-3166 alpha 2 digit country code or a UN M.49 3 digit code end
 * returns true if it should be treated like the US for regulatory purposes
 *
 * https://en.wikipedia.org/wiki/UN_M49
 */
export function isUS(countryISOCode: string | undefined): boolean {
  if (countryISOCode === undefined) {
    return false
  }

  return usTerritories.includes(countryISOCode.toUpperCase())
}
